import { createSlice } from '@reduxjs/toolkit';
import { UserInfoModel, tokenApi } from 'models/userInfoModel';

interface PropsState {
    userInfo: UserInfoModel;
    isLogged: boolean;
    agentType: any;
    apiToken: string | null;
    tokenXD: string | null;
    tokenBC: string | null;
    tokenRH: string | null;
    rememberData: {
        isRemember: boolean | null;
        account: string | null;
    };
}

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isLogged: false,
        agentType: null,
        apiToken: null,
        tokenXD: null,
        tokenBC: null,
        tokenRH: null,
        userInfo: {},
        rememberData: {
            isRemember: false,
            account: null,
        },
    } as PropsState,
    reducers: {
        login(state, action) {
            state.isLogged = action.payload;
        },
        logout(state, action) {
            state.isLogged = action.payload;
            state.userInfo = {} as UserInfoModel;
            state.tokenXD = null;
            state.tokenBC = null;
            state.apiToken = null;
            state.tokenRH = null;
        },
        cacheUserInfo(state, action) {
            state.userInfo = action.payload;
        },
        cacheTokenXD(state, action) {
            state.tokenXD = action.payload;
        },
        cacheTokenBC(state, action) {
            state.tokenBC = action.payload;
        },
        ApiToken(state, action) {
            state.isLogged = true;
            state.apiToken = action.payload;
        },
        cacheTokenRH(state, action) {
            state.tokenRH = action.payload;
        },
        updateAgentType(state, action) {
            state.agentType = action.payload;
        },
        rememberAccountAction(state, action) {
            state.rememberData = action.payload;
        },
    },
});

const { actions, reducer } = authSlice;

export const { logout, login, cacheUserInfo, cacheTokenXD, cacheTokenBC, cacheTokenRH, rememberAccountAction, ApiToken, updateAgentType } = actions;
export default reducer;
